import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { ProtectedRoute } from './router/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';
import { LoginPage } from './pages/auth/LoginPage';
import { AuthCallbackPage } from './pages/auth/AuthCallbackPage';
import { EntriesPage } from './pages/employee/EntriesPage';
import { NewEntryPage } from './pages/employee/NewEntryPage';
import { AnalyticsPage } from './pages/admin/AnalyticsPage';
import { AllEntriesPage } from './pages/admin/AllEntriesPage';
import { UsersPage } from './pages/admin/UsersPage';
import { ReleaseNotesPage } from './pages/admin/ReleaseNotesPage';
import { ProjectsPage } from './pages/admin/ProjectsPage';
import { ApprovalsPage } from './pages/employee/ApprovalsPage';
import { AuditLogPage } from './pages/admin/AuditLogPage';
import { Permission, PermissionEnum } from './types';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />

        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          {/* Employee routes */}
          <Route path="/employee/entries" element={<EntriesPage />} />
          <Route path="/employee/entries/new" element={<NewEntryPage />} />
          <Route path="/employee/approvals" element={<ApprovalsPage />} />

          {/* Admin routes — each gated by the relevant permission */}
          <Route path="/admin/analytics" element={<ProtectedRoute requirePermission={PermissionEnum.VIEW_ANALYTICS}><AnalyticsPage /></ProtectedRoute>} />
          <Route path="/admin/entries" element={<ProtectedRoute requirePermission={PermissionEnum.VIEW_ANALYTICS}><AllEntriesPage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute requirePermission={PermissionEnum.USER_MANAGEMENT}><UsersPage /></ProtectedRoute>} />
          <Route path="/admin/projects" element={<ProtectedRoute requirePermission={PermissionEnum.PROJECT_MANAGEMENT}><ProjectsPage /></ProtectedRoute>} />
          <Route path="/admin/audit-log" element={<ProtectedRoute requirePermission={PermissionEnum.VIEW_AUDIT_LOG}><AuditLogPage /></ProtectedRoute>} />
          <Route path="/admin/release-notes" element={<ProtectedRoute requirePermission={PermissionEnum.IS_MAINTAINER}><ReleaseNotesPage /></ProtectedRoute>} />
        </Route>

        <Route path="/" element={<Navigate to="/employee/entries" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
